import axios from "axios";
import { BASE_URL, SEND_CONTACTS_URL } from "@/utils/api/Urls";

/**
 * Post contacts from contact us form
 */
export const postContacts = async (
  data: IContactFields,
  captcha: ICaptchaValid
) => {
  const requestURL = `${BASE_URL}${SEND_CONTACTS_URL}`;

  try {
    const headers = {
      "Content-Type": "application/json",
      "Captcha-Input": captcha.value,
    };
    const response = await axios.post(requestURL, data, { headers });
    return response;
  } catch (err: unknown) {
    // Axios error
    if (axios.isAxiosError(err)) {
      // The request was made and the server responded with a status code
      if (err.response) {
        console.log("Error status:", err.response.status);
        return err.response;
      }

      // The request was made but no response was received
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }

    // Non-Axios error
    console.log("Non-Axios error occurred:", err);
  }
};
